<app-icon [icon]="'mm-spinner'" class="mm-icon"
          [class.mm-spinner-primary]="style === 'primary'"
          [class.mm-spinner-secondary]="style === 'secondary'"
          [class.mm-spinner-disabled]="style === 'primary'"
          [class.mm-spinner-ai]="style === 'ai'"></app-icon>
